var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_100",
    "data-name": "Group 100",
    xmlns: "http://www.w3.org/2000/svg",
    width: 185.822,
    height: 29.788,
    viewBox: "0 0 185.822 29.788",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star_FILL0_wght400_GRAD0_opsz48",
    d: "M9.558,33.062l3.378-11.043L4,15.625H15.043L18.531,4l3.487,11.625H33.062l-8.936,6.394L27.5,33.062l-8.973-6.829Z",
    transform: "translate(-4 -4)",
    fill: "#fa7e4a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "star_FILL0_wght400_GRAD0_opsz48-2",
    "data-name": "star_FILL0_wght400_GRAD0_opsz48",
    d: "M9.558,33.062l3.378-11.043L4,15.625H15.043L18.531,4l3.487,11.625H33.062l-8.936,6.394L27.5,33.062l-8.973-6.829Z",
    transform: "translate(35.191 -4)",
    fill: "#fa7e4a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "star_FILL0_wght400_GRAD0_opsz48-3",
    "data-name": "star_FILL0_wght400_GRAD0_opsz48",
    d: "M9.558,33.062l3.378-11.043L4,15.625H15.043L18.531,4l3.487,11.625H33.062l-8.936,6.394L27.5,33.062l-8.973-6.829Z",
    transform: "translate(74.38 -4)",
    fill: "#fa7e4a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "star_FILL0_wght400_GRAD0_opsz48-4",
    "data-name": "star_FILL0_wght400_GRAD0_opsz48",
    d: "M9.558,33.062l3.378-11.043L4,15.625H15.043L18.531,4l3.487,11.625H33.062l-8.936,6.394L27.5,33.062l-8.973-6.829Z",
    transform: "translate(113.572 -3.273)",
    fill: "#fa7e4a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "star_FILL0_wght400_GRAD0_opsz48-5",
    "data-name": "star_FILL0_wght400_GRAD0_opsz48",
    d: "M9.558,33.062l3.378-11.043L4,15.625H15.043L18.531,4l3.487,11.625H33.062l-8.936,6.394L27.5,33.062l-8.973-6.829Z",
    transform: "translate(152.761 -4)",
    fill: "#fa7e4a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.d6caa9d1345395b0553062a1c1630f86.svg";
export { ForwardRef as ReactComponent };